import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { associateCartWithUser } from './associate-cart-with-user';
import { loadCart, loadCartError, loadCartRequest, loadCartSuccess } from './load-cart';
export var assignCurrentCart = function assignCurrentCart() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
      var chord, _currentLocalCart$dat, _currentLocalCart$dat2, _currentDistantCart$l, _currentLocalCart$dat3, _currentLocalCart$dat4, _getState, auth, currentLocalCart, currentDistantCart, _error$response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            chord = _ref.chord;
            _context.prev = 1;
            _getState = getState(), auth = _getState.auth, currentLocalCart = _getState.cart; // if guest cart, but has more than one line item
            // we associate, and keep it as the current cart
            if (!(((_currentLocalCart$dat = currentLocalCart.data) === null || _currentLocalCart$dat === void 0 ? void 0 : (_currentLocalCart$dat2 = _currentLocalCart$dat.lineItems) === null || _currentLocalCart$dat2 === void 0 ? void 0 : _currentLocalCart$dat2.length) > 0)) {
              _context.next = 7;
              break;
            }
            _context.next = 6;
            return dispatch(associateCartWithUser());
          case 6:
            return _context.abrupt("return");
          case 7:
            // if guest cart but empty, we fetch distant order
            // and if that order has items, it is chosen as the current
            dispatch(loadCartRequest());
            _context.next = 10;
            return chord.oms.getCurrentOrder(auth.token);
          case 10:
            currentDistantCart = _context.sent;
            if (!((currentDistantCart === null || currentDistantCart === void 0 ? void 0 : (_currentDistantCart$l = currentDistantCart.lineItems) === null || _currentDistantCart$l === void 0 ? void 0 : _currentDistantCart$l.length) > 0)) {
              _context.next = 14;
              break;
            }
            dispatch(loadCartSuccess(currentDistantCart));
            return _context.abrupt("return");
          case 14:
            if (!(new Date(currentLocalCart === null || currentLocalCart === void 0 ? void 0 : (_currentLocalCart$dat3 = currentLocalCart.data) === null || _currentLocalCart$dat3 === void 0 ? void 0 : _currentLocalCart$dat3.createdAt) < new Date(currentDistantCart === null || currentDistantCart === void 0 ? void 0 : currentDistantCart.createdAt))) {
              _context.next = 17;
              break;
            }
            dispatch(loadCartSuccess(currentDistantCart));
            return _context.abrupt("return");
          case 17:
            if (!(currentLocalCart !== null && currentLocalCart !== void 0 && (_currentLocalCart$dat4 = currentLocalCart.data) !== null && _currentLocalCart$dat4 !== void 0 && _currentLocalCart$dat4.id)) {
              _context.next = 20;
              break;
            }
            _context.next = 20;
            return dispatch(associateCartWithUser());
          case 20:
            dispatch(loadCartSuccess(currentLocalCart.data));
            _context.next = 31;
            break;
          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](1);
            if (!((_context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 409)) {
              _context.next = 29;
              break;
            }
            setTimeout(function () {
              dispatch(loadCart());
            }, 100);
            _context.next = 31;
            break;
          case 29:
            dispatch(loadCartError(_context.t0));
            throw _context.t0;
          case 31:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 23]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};